// Base URL for the backend API.
//
// Extracted because this same function was copy-pasted into Settings.vue,
// Users.vue, ServiceAccounts.vue, Login.vue and ForgotPassword.vue. Those
// copies still exist; new code should import this one rather than add a sixth.
export const getApiBase = () => {
  const envUrl = process.env.VUE_APP_API_URL || 'http://127.0.0.1:10000'
  const clean = envUrl.replace(/\/$/, '')
  return clean.endsWith('/api/v1') ? clean : `${clean}/api/v1`
}

// authHeaders builds the Authorization header from the Vuex store's token.
export const authHeaders = (store) => ({
  headers: { Authorization: `Bearer ${store.state.token}` }
})
